import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from '../global';
import { GenericRequestReports } from '../domain/generic-request-reports';
import { Observable } from 'rxjs';
import { GenericResponse } from '../domain/genericResponse';
import { CustomerOrdersParameters } from '../domain/customer-orders-parameters';
import { PedidoCliente } from '../domain/pedido-cliente';

@Injectable({
  providedIn: 'root'
})
export class PedidoService {
  urlPedido: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  public urlPedidosSigamos: string;

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-08
   * @param httpClient
   */
  constructor(public httpClient: HttpClient) { 
    this.urlPedido = GLOBAL.URL_BASE+'sicaPedido';
    this.urlPedidosSigamos = GLOBAL.URL_SIGAMOS + "customerOrders";
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-30
   * @param tercero
   * Busca los pedidos de un tercero
   */
  findAllPedidosActivosByTercId(tercId:number):any{
    return this.httpClient.get(this.urlPedido+'/findAllPedidosActivosByTercId/'+tercId);
  }
  /**
   * @author Daniel Pareja Londoño
   * @version 2018-11-22
   * @param genericRequestReports 
   */
  findAllCountPedidosActivosByEspeId(genericRequestReports:GenericRequestReports):Observable<any>{
    return this.httpClient.post(this.urlPedido+'/findAllCountPedidosActivosByEspeId',genericRequestReports,this.httpOptions);
  }

  /**
   * Servicio `REST` de tipo `POST` que consulta los pedidos de un cliente en sigamos.
   * 
   * @author Andrés Felipe Vargas López
   * @version Nov 28, 2018
   * @since 6.2.4
   * @param parametros - DTO en el que se incluyen todos los parametros para consumir el servicio rest.
   * @return [ `Observable<GenericResponse>` ] - Se retorna la repuesta enviada por la peticion post http.
   */
  public consultarPedidosCliente (parametros: CustomerOrdersParameters): Observable<GenericResponse> {

    const operation: string = "getCustomersOrdersByNit";
    const url:  string = `${this.urlPedidosSigamos}/${operation}`;

    return this.httpClient.post<GenericResponse>(url, parametros, this.httpOptions);

  }

  /**
   * Servicio `REST` de tipo `POST` que consulta el numero total de pedidos de un cliente en sigamos.
   * 
   * @author Andrés Felipe Vargas López
   * @version Nov 28, 2018
   * @since 6.2.4
   * @param parametros - DTO en el que se incluyen todos los parametros para consumir el servicio rest.
   * @return [ `Observable<GenericResponse>` ] - Se retorna la repuesta enviada por la peticion post http.
   */
  public consultarTotalPedidosCliente (parametros: CustomerOrdersParameters): Observable<GenericResponse> {

    const operation: string = "getTotalCustomersOrdersByNit";
    const url:  string = `${this.urlPedidosSigamos}/${operation}`;

    return this.httpClient.post<GenericResponse>(url, parametros, this.httpOptions);
  }
}
